import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import DataSource from 'devextreme/data/data_source';
// import { Deferred } from 'devextreme/core/utils/deferred';


// class SimpleBoxViewItem extends PureComponent {
//     // constructor(props) {
//     //     super(props);
//     // }
//
//     render() {
//         // console.log('key', this.props.data[this.props.keyExpr])
//         return (
//             <div
//                 // key={this.props.data[this.props.keyExpr].toString()}
//                 className="box-view"
//                 onClick={this.props.onBoxClick}
//             >
//                 {this.props.boxTemplate(this.props.data)}
//             </div>
//         );
//     }
// }


export default class SimpleBoxView extends PureComponent {
    constructor(props) {
        super(props);

        // this.input = React.createRef();
        this.ds = new DataSource(this.props.dataSource);
        this.state = {
            dataSource: this.props.dataSource,
            filterValue: this.props.filterValue,
            _ds: [],
            boxTemplate: this.props.boxTemplate,
            // _boxTemplate: (props) => {return <></>},
            // checked: this.props.checked,
        }
        const {boxTemplate} = this.props;
        if (boxTemplate && typeof boxTemplate === 'string'){
            this.state['boxTemplate'] = window[boxTemplate];
        }


        this.setDS = this.setDS.bind(this);
        // this.boxTemplate = this.boxTemplate.bind(this);
        this.onBoxClick = this.onBoxClick.bind(this);
    }

    setDS(res) {
        // console.log('res', res)
        this.setState({
            _ds: res
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.state.filterValue !== props.filterValue) {
            // console.log('filterValue')
            this.setState({
                filterValue: props.filterValue,
            });
            this.ds.filter(props.filterValue)
            this.ds.load().done(this.setDS);
        }
        if (this.state.dataSource !== props.dataSource) {
            // console.log('dataSource')
            this.ds.dispose();
            this.ds = new DataSource(props.dataSource)
            if ((this.state.filterValue || []).length > 0) this.ds.filter(this.state.filterValue)
            this.ds.load().done(this.setDS);
            this.setState({
                dataSource: props.dataSource,
            });
        }
        // if (this.state.boxTemplate !== props.boxTemplate) {
        //     console.log('boxTemplate')
        //     // if (typeof props.boxTemplate === 'string'){
        //     this.setState({
        //         boxTemplate: props.boxTemplate,
        //         _boxTemplate: window[props.boxTemplate],
        //     });
        //     // }
        // }
    }

    componentDidMount() {
        if ((this.state.filterValue || []).length > 0) this.state.ds.filter(this.state.filterValue)
        this.ds.load().done(this.setDS);
        // const {boxTemplate} = this.props;
        // if (boxTemplate && typeof boxTemplate === 'string'){
        //     this.setState({boxTemplate: window[boxTemplate]})
        // }
    }

    onBoxClick(value, e) {
        const {setProps} = this.props;
        if (setProps) {
            const data = {
                boxClick: {
                    value: value,
                    timestamp: Date.now()
                }
            };
            setProps(data);
        }
    }

    // boxTemplate(template_id) {
    //     var tmpl = window[template_id];
    //     return function(container, options) {
    //         ReactDOM.render(tmpl(options), container);
    //     }
    // }

    render() {
        const {loading_state} = this.props;
        let {onBoxClick} = this.props;
        // let {boxTemplate} = this.props;
        // if (boxTemplate && typeof boxTemplate === 'string'){
        //     //boxTemplate = this.boxTemplate(boxTemplate);
        //     boxTemplate = window[boxTemplate];
        // }

        if (onBoxClick && typeof onBoxClick === 'string') onBoxClick = window[onBoxClick];

        // console.log('render')
        return (
            <div
                data-dash-is-loading={(loading_state && loading_state.is_loading) || undefined}
                style={{...this.props.elementAttr}}
                className={this.props.className}
            >
                {
                    this.state._ds.map(box => {
                        return React.cloneElement(this.state.boxTemplate(box), {
                            key: box[this.props.keyExpr].toString(),
                            onClick: onBoxClick && onBoxClick.bind(this, box) || this.onBoxClick.bind(this, box),

                        })
                        // console.log('item', index, box)
                        // return (
                        //     <SimpleBoxViewItem
                        //         // keyExpr={this.props.keyExpr}
                        //         key={box[this.props.keyExpr].toString()}
                        //         onBoxClick={onBoxClick && onBoxClick.bind(this, box) || this.onBoxClick.bind(this, box)}
                        //         boxTemplate={this.state.boxTemplate}
                        //         // boxTemplate={window[this.props.boxTemplate]}
                        //         data={box}
                        //     />
                        // )
                    })
                }
            </div>
        );
    }
}

SimpleBoxView.propTypes = {
    /**
     * The ID of this component, used to identify dash components
     * in callbacks. The ID needs to be unique across all of the
     * components in an app.
     */
    id: PropTypes.string,

    /**
     * Dash event
     */
    boxClick: PropTypes.object,
    /**
     * An alias for the rowTemplate property specified in React. Accepts a rendering function.
     */
    boxTemplate: PropTypes.string,
    /**
     * The class of the parent element
     */
    className: PropTypes.string,
    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies a filter expression
     */
    filterValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the key property (or properties) that provide(s) key values to access data items. Each key value must be unique. This property applies only if data is a simple array.
     */
    keyExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    /**
     * A function that is executed when a box is clicked or tapped
     */
    onBoxClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * The input's inline styles
     */
    style: PropTypes.object,
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Specifies which data field provides unique values to the UI component's value
     */
    valueExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

SimpleBoxView.defaultProps = {
    boxTemplate: undefined,
    className: 'simple-box-view',
    dataSource: null,
    filterValue: null,
    keyExpr: 'id',
    valueExpr: null,
};
